var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessAge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.896,
    height: 17.896,
    viewBox: "0 0 17.896 17.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_29067",
    "data-name": "Path 29067",
    d: "M41.476,32.528a8.948,8.948,0,1,1-8.948-8.948A8.948,8.948,0,0,1,41.476,32.528ZM38.591,29.4a1.074,1.074,0,0,0-1.07-1.07H35.258V27.245a1.5,1.5,0,0,0-1.5-1.49H31.3a1.5,1.5,0,0,0-1.5,1.5v1.084H27.536a1.074,1.074,0,0,0-1.07,1.07v6.367a1.074,1.074,0,0,0,1.07,1.07H37.52a1.074,1.074,0,0,0,1.07-1.07Zm-4.2-2.154a.633.633,0,0,0-.633-.633H31.3a.633.633,0,0,0-.633.633v1.084h3.726ZM37.52,29.2H27.536a.207.207,0,0,0-.207.2v1.067l5.2,1.321,5.2-1.321V29.4a.207.207,0,0,0-.207-.2Zm-4.88,3.451,5.08-1.29v4.4a.21.21,0,0,1-.207.207H27.536a.21.21,0,0,1-.207-.207v-4.4l5.08,1.294a.427.427,0,0,0,.23,0ZM34.8,35.1a.23.23,0,0,0,.23.234h1.819a.234.234,0,0,0,.234-.234V34.76a.234.234,0,0,0-.234-.234H35.028a.23.23,0,0,0-.23.234Z",
    transform: "translate(-23.58 -23.58)",
    fill: "#170A33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessAge);
export default __webpack_public_path__ + "static/media/BusinessAge.763e65c57108bdc719e616b7b5492333.svg";
export { ForwardRef as ReactComponent };